

export interface AbstractTimeSeriesRange {
    name: string;
}